<template>
    <div>
        <div class="phone-verification" v-show="userProfile != null && ! isPhoneVerified">
            <phone-verification></phone-verification>
        </div>
        <div class="dashboard-body" v-if="!loading_state">
            <div>
                <div v-if="latest_pool != null">
                    <pool-progress :pool="latest_pool"></pool-progress>

                    <div class="row mt-3">
                        
                        <contributors-feed
                            v-if="pool_invitees != null"
                            :contributors="pool_invitees" 
                            :pool="latest_pool">
                        </contributors-feed>

                    
                        <div class="col-lg-4 ">
                            <recent-activity-feed
                                v-if="pool_invitees != null"
                                :pool_id="latest_pool.pool_id"
                                :contributors="pool_invitees">
                            </recent-activity-feed>
                        </div>
                    </div>

                </div>

                <div class="row" v-else>
                    <div class="col-md-12">
                        <div class="card shadow-sm border-0">
                            <div class="card-body">
                                <div class="d-flex flex-column justify-content-center align-items-center" style="height:180px;">
                                    <p class="h6 text-center mt-2  mb-2">
                                        <span class="fa fa-chart-pie"></span> 
                                        Nothing to see yet.
                                    </p>

                                    <p class="mt-5">Questions? <a href="#">Visit our FAQ Page.</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mt-3">
                        <div class="card shadow-sm border-0">
                            <div class="card-body">
                                <div class="d-flex flex-column justify-content-center align-items-center" style="height:100%;">
                                    <img src="@/assets/illustrations/zero-image.png" class="img-fluid zero-image" alt="">
                                    <div class="mt-3 text-center">
                                        <!-- <p class="m-0">You haven't created any Moneypools.</p> -->
                                        <p class="h6 text-center mb-2 mt-4">
                                            Create your first Moneypool. Simplify your group collections.
                                        </p>
                                        <router-link to="/create" tag="button" class="btn btn-outline-dark btn-sm my-4">Create a pool</router-link>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="loading_state" v-if="loading_state">
            <p>loading...</p>
        </div>
    </div>
<!-- UmunyaIrikefe6902087757 -->
</template>


<script>
import { mapGetters, mapState } from 'vuex';
import PoolProgress from '@/components/PoolProgress';
import ContributorsFeed from '@/components/ContributorsFeed';
import RecentActivityFeed from '@/components/RecentActivityFeed'
import PhoneVerification from '@/components/PhoneVerification';

export default {
    name: 'DashboardView',
    components: {
        PhoneVerification,
        ContributorsFeed,
        PoolProgress,
        RecentActivityFeed
    },
    created() {
        this.$store.dispatch('getPools');
    },
    watch: {
        latest_pool() {
            this.$store.dispatch('listInvitedContributors', this.latest_pool.pool_id)
        }
    },
    computed: {
        ...mapGetters([
            'userProfile',
            'latest_pool',
            'pool_invitees'
        ]),
        ...mapState([
            'loading_state'
        ]),

        isEmailVerified() {
            const { email_verified_at } = this.userProfile;

            return email_verified_at == null ? false : true;
        },

        isPhoneVerified() {
            const { verification } = this.userProfile;

            if (verification.length == 0) {
                return false;
            }

            const [ { type, is_verified } ] = verification;

            return (type == 'phone' && is_verified == false) ? false : true;
        },

    }, 
    methods:{
        //
    }
}
</script>

<style>
div.circle-progress-container {
    width: auto !important;
}
.circle-progress-inner > span {
    font-size: 25px !important;
    font-weight: bold !important;
}
.avatar {
  vertical-align: middle;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
@media (min-width: 760px) {
    .zero-image {
        height: 300px;
    }
}
</style>